'use client';

import { cn } from '../utils/cn';

/** Static preview asset path (Vite `public/`). Uses accent-aware rendering in previews. */
export const PROFILE_PREVIEW_SAMPLE_AVATAR_PATH =
  '/assets/images/preview-sample-avatar.svg';

export function isProfilePreviewSampleAvatarPath(
  path: string | null | undefined,
): boolean {
  const trimmed = path?.trim() ?? '';
  if (!trimmed) return false;
  return (
    trimmed === PROFILE_PREVIEW_SAMPLE_AVATAR_PATH ||
    trimmed.endsWith('/preview-sample-avatar.svg')
  );
}

type SampleProfileAvatarProps = {
  className?: string;
};

/** Template/app preview placeholder – circle uses `--primary` (accent) instead of fixed SVG blues. */
export function SampleProfileAvatar({ className }: SampleProfileAvatarProps) {
  return (
    <div
      className={cn(
        'flex h-32 w-32 shrink-0 items-center justify-center overflow-hidden rounded-full bg-primary-solid',
        className,
      )}
      aria-hidden
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 128 128"
        className="h-full w-full"
      >
        <path
          fill="var(--primary-solid-foreground, #ffffff)"
          fillRule="evenodd"
          d="M64 34a18 18 0 1 0 0 36 18 18 0 0 0 0-36Zm-30 66.5C34 82.2 47.8 72 64 72s30 10.2 30 28.5V110H34v-27.5Z"
        />
      </svg>
    </div>
  );
}
